<mat-form-field class="form-item">
  <mat-label>Controller</mat-label>
  <input type="text" placeholder="Search controller" matInput [formControl]="controllerControl"
    [matAutocomplete]="autoController" (focus)="onFocus()" (blur)="updateController($event.target.value)"
    (input)="controllerChanges.next($event.target.value)" />
  <mat-autocomplete #autoController="matAutocomplete" (optionSelected)="setControllerChangeAction($event)">
    @for (controller of controllerSuggestions | async; track controller; let i = $index) {
      <mat-option [value]="controller">
        {{ controller }}
        @if (i !== 0) {
          <button class="navigateBtn" (click)="navigateTo(controller)" mat-stroked-button>Go to</button>
        }
      </mat-option>
    }
  </mat-autocomplete>
  @if (controllerControl.hasError('required')) {
    <mat-error>
      Controller is Required
    </mat-error>
  }
  @if (controllerControl.hasError('noOption')) {
    <mat-error>
      Controller not Found
    </mat-error>
  }
</mat-form-field>